module.exports = __webpack_public_path__ + "static/adults_program_session-af3e19848e995ec41ba68a220cb35494.jpg";